import { render } from "./safetyRecord.vue?vue&type=template&id=9c409fd6&scoped=true"
import script from "./safetyRecord.vue?vue&type=script&lang=js"
export * from "./safetyRecord.vue?vue&type=script&lang=js"

import "./safetyRecord.vue?vue&type=style&index=0&id=9c409fd6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c409fd6"]])

export default __exports__